import NewClientForm from '../NewClientForm/NewClientForm'
import './NewClient.css'

export default function NewClient({user, toggleNotifications}) {
  return (
    <div className='NewClient modal fade' id='newClientModal' data-bs-keyboard="false" aria-labelledby={`newClientHeader`}>
      <NewClientForm user={user} toggleNotifications={toggleNotifications} />
    </div>
  )
}
